import { gql } from '@apollo/client';

export const REUPLOAD_TALENT_CV_TO_TRIMOJI = gql`
    mutation ReUploadTalentCVToTrimoji($talentId: ID!) {
        reUploadTalentCVToTrimoji(talentId: $talentId) {
            messageId
            success
            message
        }
    }
`;

export const BATCH_TRIGGER_TRIMOJI_MISSING_RESUME_IDS = gql`
    mutation BatchTriggerTrimojiMissingResumeIds($limit: Int) {
        batchTriggerTrimojiMissingResumeIds(limit: $limit) {
            triggeredCount
            skippedCount
            totalFound
        }
    }
`;
